import { createSelector } from 'reselect';
import { State } from 'reducers';

const getAdminState =
    (state: State) =>
        state.admin;

const getSqlState =
    createSelector(getAdminState,
        state => state && state.sql
    );

export const getSqlRequest =
    createSelector(getSqlState,
        state => state && state.sql
    );

export const isSqlPending =
    createSelector(getSqlState,
        state => state && !!state.pending
    );

export const getSqlResults =
    createSelector(getSqlState,
        state => state && state.results
    );

export const getSqlError =
    createSelector(getSqlState,
        state => state && state.err
    );

const getCacheCliState =
    createSelector(getAdminState,
        state => state && state.cacheCli
    );

export const isCacheCliPending =
    createSelector(getCacheCliState,
        state => state && !!state.pending
    );

export const getCacheCliCommands =
    createSelector(getCacheCliState,
        state => state ? state.commands : []
    );

export const getCacheCliResults =
    createSelector(getCacheCliState,
        state => state && state.results
    );

export const getCacheCliErrorMessage =
    createSelector(getCacheCliState,
        state => state?.errorMessage
    );

const getUploadsState =
    createSelector(getAdminState,
        state => state && state.uploads
    );

export const isLoadingUploads =
    createSelector(getUploadsState,
        state => !!(state && state.loading)
    );

export const getUploads =
    createSelector(getUploadsState,
        state => state && state.data
    );

const getFilename =
    (state: State, { filename }: any) => filename
;
export const getUpload =
    createSelector(
        getUploads,
        getFilename,
        (uploads, filename) => uploads && uploads[filename]
    );

const getUploadState =
    createSelector(getAdminState,
        state => state && state.upload
    );

export const getUploadProgress =
    createSelector(getUploadState,
        state => state && state.progress
    );

export const isUploading =
    createSelector(getUploadState,
        state => !!(state && state.progress)
    );

export const getUploadError =
    createSelector(getUploadState,
        state => state && state.error
    );
